import type { Entities } from "../types"

export const entities: Entities = new Map([
  [
    "euler-dao",
    {
      name: "Euler DAO",
      logo: "entities/euler.svg",
      description:
        "The Euler DAO is the organisation responsible for the creation of the Euler lending/borrowing platform.",
      url: "https://euler.finance/",
      addresses: {
        "0x1e13B0847808045854Ddd908F2d770Dc902Dcfb8": "Euler DAO Multisig",
        "0xfe959D7A49EAE5Aaa821b71de315Fb3Adc7a52Ad":
          "Euler Vault Access Control Governor",
      },
      social: {
        twitter: "eulerfinance",
        youtube: "EulerFinance",
        discord: "https://discord.euler.finance/",
        telegram: "eulerfinance_official",
        github: "euler-xyz",
      },
    },
  ],
  [
    "gauntlet",
    {
      name: "Gauntlet",
      logo: "entities/gauntlet.svg",
      description:
        "Gauntlet's applied research and optimization teams model market risk, economic incentives, and drive sustainable growth for crypto's top protocols, chains, and onchain treasuries.",
      url: "https://www.gauntlet.xyz/",
      addresses: {
        "0xfe959D7A49EAE5Aaa821b71de315Fb3Adc7a52Ad":
          "Euler Vault Access Control Governor",
      },
      social: { twitter: "gauntlet_xyz" },
    },
  ],
  [
    "apostro",
    {
      name: "Apostro",
      logo: "entities/apostro.png",
      description:
        "Building a better way to self-regulate markets to avoid oracle attacks.",
      url: "https://www.apostro.xyz/",
      addresses: {
        "0xfD4CD4f4e6e7288E5F68af2D282Cfb872Cea144C": "Apostro Timelock",
        "0xf726311F85D45a7fECfFbC94bD8508a0A39958c6": "Apostro Multisig",
      },
      social: { twitter: "apostroxyz" },
    },
  ],
  [
    "re7-labs",
    {
      name: "Re7 Labs",
      logo: "entities/re7labs.png",
      description:
        "Re7 Labs is the innovation arm of digital asset investment firm Re7 Capital, taking the practical experience of DeFi risk management to on-chain vaults.",
      url: "https://www.re7labs.xyz/",
      addresses: {
        "0x184d597Be309e11650ca6c935B483DcC05551578": "Re7 Labs Euler Multisig",
      },
      social: { twitter: "Re7Labs" },
    },
  ],
  [
    "alterscope",
    {
      name: "Alterscope",
      logo: "entities/alterscope_wb.png",
      description:
        "Alterscope provides the platform for processing and modelling risk in real-time across chains, protocols, and liquidity pools.",
      url: "https://www.alterscope.org/",
      addresses: {
        "0x2e571f334fe06A6a2741dd0E4cb5Bc7C1F8Af808": "Alterscope Multisig",
      },
      social: { twitter: "Alterscope" },
    },
  ],
  [
    "edge-capital",
    {
      name: "Edge UltraYield",
      logo: "entities/edge.png",
      description:
        "Edge Capital is a leading market-neutral hedge fund that manages capital for largest fund of funds, institutional investors and leading crypto foundations and treasuries since 2020",
      url: "https://edgecapital.xyz/",
      addresses: {
        "0x1280e86Cd7787FfA55d37759C0342F8CD3c7594a": "Edge Capital Multisig",
      },
      social: { twitter: "EdgeCapitalMgmt" },
    },
  ],
  [
    "alphagrowth",
    {
      name: "AlphaGrowth",
      logo: "entities/alphagrowth.svg",
      description:
        "Real stewardship, real growth. AlphaGrowth drives the blockchain industry forward by expanding token utility and accessibility through strategic partnerships and integrations.",
      url: "https://alphagrowth.io/",
      addresses: {
        "0x4f894Bfc9481110278C356adE1473eBe2127Fd3C": "Reservoir DAO Multisig",
      },
      social: { twitter: "alphagrowth1" },
    },
  ],
])
